module.exports = __webpack_public_path__ + "static/media/01D.7f13f1b6.png";